module.exports = __webpack_public_path__ + "img/58_15.f71b740b.png";